import React from "react";
import style from "./index.module.scss";
import { Dropdown, Icon, Menu } from "antd";
import classNames from "classnames";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";

interface BatchPickerProps {
    value?: string;
    onChange?(value: string): void;
}

export default function LocalBatchPicker({
    value,
    onChange
}: BatchPickerProps) {
    const batchList = useAtomValue(termListAtom);

    const menu = (
        <Menu className={style.menu}>
            {batchList?.map(item => (
                <Menu.Item
                    key={item.batchNo}
                    onClick={() => onChange?.(item.batchNo)}
                    className={classNames(style.menuItem, {
                        [style.selected]: item.batchNo === value
                    })}>
                    {item.batchName}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className={style.root}>
            <Dropdown overlay={menu} className={style.dropdown}>
                <div>
                    {batchList?.find(item => item.batchNo === value)?.batchName}{" "}
                    <Icon type="down" />
                </div>
            </Dropdown>
        </div>
    );
}
